import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/styles/global.css';

const consent = document.cookie.includes("cookieConsent=accepted") ? "accepted" :
                document.cookie.includes("cookieConsent=declined") ? "declined" : null;

const app = createApp(App)
app.config.globalProperties.$consentGiven = consent;

app.use(router).mount('#app');